var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86393 12.4395C7.03452 12.4395 7.20529 12.3732 7.33529 12.2428L7.39258 12.1855C7.65325 11.9249 7.65325 11.5028 7.39258 11.2428L4.81706 8.66732L13.5306 8.66732C13.8986 8.66732 14.1973 8.36865 14.1973 8.00065C14.1973 7.63265 13.8986 7.33398 13.5306 7.33398L4.81706 7.33398L7.39258 4.75846C7.65325 4.4978 7.65325 4.07575 7.39258 3.81575L7.33529 3.75846C7.07462 3.4978 6.65258 3.4978 6.39258 3.75846L2.62175 7.5293C2.36108 7.78996 2.36108 8.212 2.62175 8.472L6.39258 12.2428C6.52291 12.3732 6.69335 12.4395 6.86393 12.4395Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.136454f11d830cdb76874d12755e4766.svg";
export { ForwardRef as ReactComponent };